import './App.css';
import React from 'react'
import Routes from "./Routes";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet, HelmetProvider} from 'react-helmet-async';

function App() {

    return (
        <HelmetProvider>

            <Container fluid>

                <Helmet>
                    <style>{'body { background-color: black; }'}</style>
                </Helmet>

                <Row>
                    <Col className="p-0">
                        <Routes/>
                    </Col>
                </Row>

            </Container>

        </HelmetProvider>
    );
}

export default App;